export const standardFonts = [
    'Arial (sans-serif)',
    'Verdana (sans-serif)',
    'Helvetica (sans-serif)',
    'Tahoma (sans-serif)',
    'Trebuchet MS (sans-serif)',
    'Times New Roman (serif)',
    'Georgia (serif)',
    'Garamond (serif)',
    'Courier New (monospace)',
    'Brush Script MT (cursive)'
] as const;

export const googleFonts = [
    'Roboto (sans-serif)',
    'Open Sans (sans-serif)',
    'Noto Sans JP (sans-serif)',
    'Lato (sans-serif)',
    'Montserrat (sans-serif)',
    'Roboto Condensed (sans-serif)',
    'Source Sans Pro (sans-serif)',
    'Oswald (sans-serif)',
    'Poppins (sans-serif)',
    'Noto Sans (sans-serif)',
    'Raleway (sans-serif)',
    'Roboto Slab (serif)',
    'Merriweather (serif)',
    'Playfair Display (serif)',
    'Lora (serif)',
    'PT Serif (serif)',
    'Noto Serif (serif)',
    'Libre Baskervill (serif)',
    'Bitter (serif)',
    'Crimson Text (serif)',
    'Source Serif Pro (serif)',
    'Zilla Slab (serif)',
    'Antic Slab (serif)',
    'Arvo (serif)',
    'Beabs Neue (display)',
    'Lobster (display)',
    'Staatliches (display)',
    'Abril Fatface (display)',
    'Fredoka One (display)',
    'Baloo 2 (display)',
    'Bangers (display)',
    'Special Elite (display)',
    'Carer One (display)',
    'Yeseva One (display)',
    'Black Ops One (display)',
    'Dancing Script (handwriting)',
    'Indie Flower (handwriting)',
    'Architects Daughter (handwriting)',
    'Inconsolata (monospace)'
] as const;

export type OnlinePagesFontTypeEnum =
    | typeof standardFonts[number]
    | typeof googleFonts[number];

export const fontWeights = ['200', '300', '400', '500', '600', '700'] as const;

export type OnlinePagesFontWeightEnum = typeof fontWeights[number];

export const isStandardFont = (type: string | undefined) =>
    standardFonts.includes(type as typeof standardFonts[number]);

export const isGoogleFont = (type: string | undefined) =>
    googleFonts.includes(type as typeof googleFonts[number]);

export const isFont = (
    type: string | undefined
): type is OnlinePagesFontTypeEnum =>
    isStandardFont(type) || isGoogleFont(type);

export const isFontWeight = (
    weight: string | undefined
): weight is OnlinePagesFontWeightEnum =>
    fontWeights.includes(weight as OnlinePagesFontWeightEnum);
